export const ASSESSMENT_BUTTONS = {
  reorder: 'reorder',
  remove: 'remove',
  printPreview: 'printPreview',
  scoringGuide: 'scoringGuide',
  scoringWorksheet: 'scoringWorksheet',
  assign: 'assign',
  edit: 'edit',
  copy: 'copy',
  addQuestions: 'addQuestions',
  copyQuestion: 'copyQuestion',
  viewQuizSummary: 'viewQuizSummary',
};
